import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyBk4LNmYciPhdE0vnjuE8o24gq9ew9sV9k',
  authDomain: 'sandbox-99ed1.firebaseapp.com',
  databaseURL: 'https://sandbox-99ed1.firebaseio.com',
  projectId: 'sandbox-99ed1',
  storageBucket: 'sandbox-99ed1.appspot.com',
  messagingSenderId: '1060451714985',
  appId: '1:1060451714985:web:f477f9b9ecab12dcc266b8'
}

firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const commentsCollection = db.collection('comments')

export { firebase, db, commentsCollection }
